import { Module, VuexModule, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "@/store/index";

export interface ITooltipModule {
  _isShow: boolean;
}

@Module({ dynamic: true, store, name: "tooltip", namespaced: true, preserveState: false })
class TooltipModule extends VuexModule implements ITooltipModule {
  public _isShow = false;

  @Mutation
  public changeIsShow(isShow: boolean) {
    this._isShow = isShow;
  }

  @Action({ rawError: true })
  public commitIsShow(isShow: boolean) {
    this.context.commit("changeIsShow", isShow);
  }

  public get isShow() {
    return this._isShow || false;
  }
}

export default getModule(TooltipModule);
